/**
 * Configuration for the product listing filters.
 * Defines how each category type is mapped to filter fields.
 */

export const FILTER_CONFIG = {
  price: {
    id: "price",
    label: "Price Range",
    type: "price",
    min: 0,
    max: 5000,
    step: 100,
  },
  categories: {
    id: "id",
    label: "Categories",
    type: "checkbox",
    dataKey: "subTypes",
  },
  flavors: {
    id: "flavour_ids",
    label: "Flavors",
    type: "checkbox",
    dataKey: "flavors.items",
  },
  collections: {
    id: "id",
    label: "Collections",
    type: "radio",
    dataKey: "items", // Used when isCollection is true
  },
  themeCakes: {
    id: "themeCake",
    label: "Theme Cakes",
    type: "checkbox",
    dataKey: "themeCakes.items",
  }
};

export type FilterConfigKey = keyof typeof FILTER_CONFIG;
